<template>
  <div class="container-fluid">
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="letter-wrap">
        <div class="note-wrap">
          <div class="letter-title">
            提醒報到
          </div>
          <div class="note-title">可動態套入信件內容，請參考以下參數</div>
          <div class="note-table">
            <table v-if="mailParameter">
              <tr v-for="(item, index) in mailParameter" :key="index">
                <th>{{ item.MailParameterName }}</th>
                <td>
                  <span>{{</span>{{ item.MailParameterCode }}<span>}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <form>
          <div class="info-wrap">
            <div class="field-wrap">
              <div class="form-group">
                <ValidationProvider
                  tag="div"
                  :name="i18n('Template.MailSubject')"
                  class="w-100"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="input-subject">
                    <span class="mark">*</span>
                    {{ i18n("Template.MailSubject") }}
                  </label>
                  <input
                    type="text"
                    id="input-subject"
                    class="form-control w-100"
                    v-model.trim="mail.MailTemplateSubject"
                  />
                  <p v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="form-group">
            <ValidationProvider
              tag="div"
              :name="i18n('Template.MailContent')"
              class="w-100"
              rules="required"
              v-slot="{ errors }"
            >
              <label for="">
                <span class="mark">*</span>
                {{ i18n("Template.MailContent") }}
              </label>
              <VueEditor
                style="background: rgb(255, 255, 255)"
                v-model="mail.MailTemplateBody"
              />
              <p v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>

          <div class="button-wrap center" style=" margin-top: 25px">
            <button
              type="button"
              class="btn btn-success"
              @click="handleSubmit(updateMailTemplate)"
            >
              {{ i18n("Buttons.Save") }}
            </button>
          </div>
        </form>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NoticeOnBoard",

  data() {
    return {
      // 信件參數
      mailParameter: {},
      // 信件資訊
      mail: {},
    };
  },

  methods: {
    // 編輯 提醒報到通知範本
    updateMailTemplate() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .putMailTemplate({
          ...this.mail,
          UpdateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "範本編輯成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
        });
    },

    async getData() {
      this.updateLoading(true);
      
      // 取得 信件範本內容
      const content = await this.$api.mailTemplate.getMailTemplateDetail(
        "14252D63-7EE4-40CB-AA34-BC1541BBF9A6"
      );
      this.mail = { ...content.data };

      // 取得 信件範本參數
      const parameter = await this.$api.mailTemplate.getMailParameter(this.mail.MailCategoryGuid);
      this.mailParameter = parameter.data;

      this.updateLoading(false);
    },

    // loading
    ...mapActions(['updateLoading']),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    }
  },

  created() {
    this.getData();
  },
};
</script>
